import { useHistory } from 'react-router-dom';

function Button(props) {
    let history = useHistory();
    var height = props.height === undefined ? "60" : props.height;
    var width = props.width === undefined ? "350" : props.width;
    const text = props.text === undefined ? "" : props.text;
    var onClick = props.onClick === undefined ? () => { } : props.onClick;
    var interactable = props.interactable === undefined ? true : props.interactable;
    height = height.endsWith("%") ? height : height + "px";
    width = width.endsWith("%") ? width : width + "px";
    var buttonClassName = interactable ? "relative grid place-items-center shrink-0" : "relative grid place-items-center shrink-0 pointer-events-none";
    if (typeof onClick === "string") {
        var path = onClick;
        onClick = () => history.push({ pathname: path });
    }

    return (
        <button
            onClick={onClick}
            style={{ width, height }}
            className={buttonClassName}
        >
            <div className="absolute inset-0 bg-[#dedede] dark:bg-[#3F3F46] rounded-[45px]" />
            <div className="absolute inset-0 border-2 border-black rounded-[45px]" />
            <p className="font-['Inter:Medium',sans-serif] font-medium  leading-[1.45] z-[1]">
                {text}
            </p>
        </button>
    );
} export default Button